import React, { useState, useEffect } from 'react';
import Landing from './pages/Landing';
import Test from './pages/Test';
import EmailCapture from './pages/EmailCapture';
import Results from './pages/Results';
import Unsubscribe from './pages/Unsubscribe';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import CookieBanner from './components/CookieBanner';
import './App.css';

function getSection() {
  const p = window.location.pathname;
  if (p === '/privacy') return 'privacy';
  if (p === '/terms')   return 'terms';
  if (p === '/unsubscribe') return 'unsub';
  return 'home';
}

export default function App() {
  const [page, setPage]         = useState('landing');
  const [result, setResult]     = useState(null);
  const [email, setEmail]       = useState('');
  const [tracking, setTracking] = useState({ cid:'', uid:'' });
  const [cookieConsent, setCookieConsent] = useState(null);
  const section = getSection();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const cid = params.get('cid') || sessionStorage.getItem('cid') || '';
    const uid = params.get('uid') || sessionStorage.getItem('uid') || '';
    if (cid) sessionStorage.setItem('cid', cid);
    if (uid) sessionStorage.setItem('uid', uid);
    setTracking({ cid, uid });
    const saved = localStorage.getItem('cookie_consent');
    if (saved !== null) setCookieConsent(saved === 'true');

    fetch('/api/track.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page: window.location.pathname + window.location.search,
        referer: document.referrer,
        cid, uid,
        lang: navigator.language,
        tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
        screen: `${window.screen.width}x${window.screen.height}`,
      })
    }).catch(() => {});
  }, []);

  const handleConsent = (accepted) => {
    setCookieConsent(accepted);
    localStorage.setItem('cookie_consent', accepted ? 'true' : 'false');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
  };

  if (section === 'privacy') return <Privacy />;
  if (section === 'terms')   return <Terms />;
  if (section === 'unsub')   return <Unsubscribe />;

  return (
    <div className="app">
      {page === 'landing' && <Landing onStart={() => setPage('test')} />}
      {page === 'test'    && <Test onComplete={(res) => { setResult(res); setPage('capture'); }} />}
      {page === 'capture' && (
        <EmailCapture
          result={result}
          tracking={tracking}
          cookieConsent={cookieConsent}
          onSubmit={(em) => { setEmail(em); setPage('results'); }}
        />
      )}
      {page === 'results' && <Results result={result} email={email} onRetake={() => setPage('landing')} />}
      {cookieConsent === null && (
        <CookieBanner
          onAccept={() => handleConsent(true)}
          onDecline={() => handleConsent(false)}
        />
      )}
    </div>
  );
}
